namespace Gamification.Gamification {
    export interface ProdottiEsperienzeTaskForm {
        IdProdottoEsperienza: Serenity.IntegerEditor;
        IdentifierTask: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.TextAreaEditor;
    }

    export class ProdottiEsperienzeTaskForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiEsperienzeTask';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiEsperienzeTaskForm.init)  {
                ProdottiEsperienzeTaskForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.TextAreaEditor;

                Q.initFormType(ProdottiEsperienzeTaskForm, [
                    'IdProdottoEsperienza', w0,
                    'IdentifierTask', w1,
                    'Nome', w1,
                    'Descrizione', w2
                ]);
            }
        }
    }
}
